var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"title"},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_setup.title))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }